// @flow
import React from 'react';
import nanoid from "nanoid";
import cookies from "react-cookies"
import axios from "axios" ;
import config from 'react-global-configuration';



class LineLogin extends React.Component {

  constructor(){
    super()
    this.authBtnHandler = this.authBtnHandler.bind(this)
    this.getToken = this.getToken.bind(this)
    var url = new URL(window.location)
    var params = new URLSearchParams(url.search);
    var code = null
    var state = null


    if(params){
      code = params.get("code")
      state = params.get("state")
    }
    this.state = {
      code:code,
      state:state,
      status:0,
      token:null,
      user_id:null,
      user_name:null
    }
  }


  componentDidMount() {
    this._isMounted = true;
    var _state = cookies.load("state")

    if(_state && this.state.state == _state){
      this.getToken()
    }else{
      this.setState({
        code:null,
        state:null
      })
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  getToken(){
    const p = this

    axios.get(config.get("API_AUTH_PATH") + config.get("API_LINE_PATH") + "/" + this.props.path + "/" + this.state.code)
    .then(function (response) {
      p.setState({
        token:response.data.line.access_token
      })
      p.getId()
    })
    .catch(function (error) {

      p.setState({
        code:null,
        state:null
      })
    });

  }
  getId(){
    const p = this

    axios({headers:{'Authorization':'Bearer ' +this.state.token}, url:'https://api.line.me/v2/profile'})
    .then(function (response) {
      p.setState({
        user_id:response.data.userId,
        user_name:response.data.displayName
      })
      p.props.responseLine(response.data.userId,response.data.displayName, response.data.pictureUrl)
    })
    .catch(function (error) {

      p.setState({
        code:null,
        state:null
      })
    });
  }
  authBtnHandler(){
    const _state = nanoid(7)
    cookies.save("state",_state,{path:"/",maxAge:10*60})
    window.location = "https://access.line.me/oauth2/v2.1/authorize?response_type=code&client_id=" + this.props.client_id+ "&redirect_uri=" + this.props.redirect_uri + "&state=" + _state + "&scope=" +this.props.scope
  }

  render() {
    var html = ""
    if(this.state.user_id){

    }else if(this.state.token){

    }else if(this.state.state && this.state.code ){

    }else{
      html=<button className="btn-line" onClick={this.authBtnHandler}>
      <i className="fab fa-line"></i>{this.props.textButton}</button>
    }

    return (
      <div>{html}</div>
    );
  }
}

export default LineLogin;



// WEBPACK FOOTER //
// ./src/components/parts/LineLogin.js